import React, { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { SuperSEO } from "react-super-seo";

import { Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import { Link, NavLink } from "react-router-dom";
import { groupByMultiple, makeUrl, upperCase } from "../../utils";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import PageContent from "../programmes/department/pageContent";
import CourseList from "../programmes/department/courseList";
import SyllabusList from "../programmes/department/syllabusList";
import FaulctyList from "../programmes/department/faulctyList";

const DepartmentLayout = (props) => {
  const context = useContext(PsContext);

  const [departmentData, setDepartmentData] = useState([]);
  const [dept, setDept] = useState([]);
  const [loader, setLoader] = useState(false);

  const [hashPath, setHashPath] = useState("");

  useEffect(() => {
    loadData();
  }, [JSON.stringify(props.match)]);

  useEffect(() => {
    if (props.location.hash) setHashPath(props.location.hash);
    else setHashPath("#about");
  }, [props.location.hash]);

  const loadData = () => {
    setLoader(true);
    setDepartmentData([]);
    const form = new FormData();
    //form.append("id", props.match.params.id);
    let id = props.match.params.id;
    axios.post(ServiceUrl.DEPARTMENTS).then((res) => {
      if (res["data"].status == "1") {
        let m = res["data"].data.find((item) => item.id == id);
        setDepartmentData(res["data"].data);
        setDept(m);
      }
      setLoader(false);
    });
  };

  const getDepartments = () => {
    let m = groupByMultiple(departmentData, function (obj) {
      return [obj.dept_type];
    });
    return m;
  };

  const deptLink = (items) => {
    return items.map((item) => (
      <li style={{ padding: "10px 0px" }}>
        <i className="fa-solid fa-chevron-right me-2 "></i>
        <NavLink
          to={`/department/${item.id}/${makeUrl(item.department)}`}
          activeClassName="text-danger"
          className="fs-14 "
        >
          {item.department}
        </NavLink>
      </li>
    ));
  };

  const shortMenus = [
    { title: "About", path: "#about" },
    { title: "Vision & Mission", path: "#vision_mission" },
    { title: "Courses Offered", path: "#courses" },
    { title: "Faculty", path: "#faculty" },
    { title: "Syllabus", path: "#syllabus" },
    { title: "Activities", path: "#activities" },
    { title: "Awards", path: "#awards" },
    { title: "Placements", path: "#placements" },
    { title: "Funded Projects", path: "#fundedprojects" },
    { title: "Research Guides", path: "#researchguide" },
    { title: "University Ranks", path: "#universityranks" },
  ];

  const hashActiveClass = (item) => {
    return hashPath == item ? "text-danger" : "";
  };

  return (
    <>
      <section>
        <div className="head-2">
          <div className="container">
            <div className="head-2-inn head-2-inn-padd-top">
              {!loader && dept.id && (
                <h2 className="text-white">
                  Department of {dept?.department}
                  {/*<span className="ms-2">
                    ({dept.dept_type == "aided" ? "Aided" : "Un-Aided"})
              </span>*/}
                </h2>
              )}
              {/*<p>Fusce id sem at ligula laoreet hendrerit venenatis sed purus. Ut pellentesque maximus lacus, nec pharetra augue.</p>
                    <div className="event-head-sub">
                        <ul>
                            <li>Topic: Global warming</li>
                            <li>Time: 09:15 am – 5:00 pm</li>
                            <li>Location: Illunois</li>
                        </ul>
					</div>*/}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container-fluid com-sp pad-bot-70 pg-inn ps_min_height">
          <SuperSEO
            title={`Department of ${dept?.department}`}
            description={`Department of ${dept?.department}`}
            lang="en"
          />

          <Row>
            <Col md={3}>
              <div className="de-left-tit pt-2 pb-1">
                <h4 className="fs-14">Menu</h4>
              </div>
              <div className="ho-event">
                <ul className="ps__sidebar__links ps-0">
                  {shortMenus.map((item, i) => {
                    return (
                      <li>
                        <i className="fa-solid fa-chevron-right "></i>
                        <NavLink
                          to={item.path}
                          className="fs-14"
                          activeClassName={hashActiveClass(item.path)}
                        >
                          {item.title}
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Col>
            <Col md={6}>
              <div className="shadow-sm p-3" style={{ overflowX: "auto" }}>
                <PageContent
                  pageId={hashPath}
                  withSlider={hashPath == "#about" ? true : false}
                  {...props}
                />
                {hashPath == "#courses" && <CourseList {...props} />}
                {hashPath == "#syllabus" && <SyllabusList {...props} />}
                {hashPath == "#faculty" && <FaulctyList {...props} />}
              </div>
            </Col>
            <Col md={3}>
              <div className="de-left-tit ">
                <h4 className="fs-14">Departments</h4>
              </div>
              <div className="ho-event">
                <ul className="ps__sidebar__links ps-0">
                  {getDepartments().map((item, i) => {
                    return (
                      <>
                        <div className="fs-14 py-2 text-center fw-bold">
                          {upperCase(item[0].dept_type)}
                        </div>
                        {deptLink(item)}
                      </>
                    );
                  })}
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default DepartmentLayout;
